module.exports = __webpack_public_path__ + "img/ring_g_l_1_1.d00e28b8.png";